import z from "zod";
import { zUid } from "src/types/zUid";

const zBom3Behavior = z.enum(["NONE", "COLOR_MODEL", "SIZE_VARIATION"]);
export type ZBom3Behavior = z.infer<typeof zBom3Behavior>;

export const zBom3PosColumn = z.object({
  id: zUid,
  displayName: z.string(),
  type: z.number(),
  viewStyle: z.string().nullish(),
  behavior: zBom3Behavior,
  targetType: z
    .number()
    .nullish()
    .describe("Только для ссылок. Тип того атрибута, на который ведёт ссылка."),
});
export type ZBom3PosColumn = z.infer<typeof zBom3PosColumn>;

export const zBom3PosCellValue = z.object({
  value: z
    .string()
    .nullable()
    .describe("Строка интерпретируется в зависимости от типа атрибута"),
  // Только для выбора материала
  label: z.string().nullish(),
  // Только для цветовой модели
  colorModelName: z.string().nullish(),
  color: z.string().nullish(),
  image: z.string().nullish(),
});
export type ZBom3PosCellValue = z.infer<typeof zBom3PosCellValue>;

export const zBom3PosRow = z.object({
  rowId: zUid,
  attributes: z.record(zUid, zBom3PosCellValue),
});
export type ZBom3PosRow = z.infer<typeof zBom3PosRow>;

export const zBom3PosMaterial = z.object({
  sectionId: z.string(),
  sectionName: z.string(),
  rows: zBom3PosRow.array(),
});
export type ZBom3PosMaterial = z.infer<typeof zBom3PosMaterial>;

const zBom3PosPermission = z.enum([
  "CREATE",
  "VIEW",
  "UPDATE",
  "UPDATE_STATE",
  "DELETE",
]);
export type ZBom3PosPermission = z.infer<typeof zBom3PosPermission>;

export const zBom3Positions = z.object({
  permissions: zBom3PosPermission.array(),
  schema: z.object({
    attributes: zBom3PosColumn.array(),
  }),
  sections: zBom3PosMaterial.array(),
});
export type ZBom3Positions = z.infer<typeof zBom3Positions>;
